module.exports = __webpack_public_path__ + "img/Nutrition.18909323.svg";